import { queryOptions, useQuery } from "@tanstack/react-query";
import invariant from "tiny-invariant";
import { Address } from "viem";
import { useAccount, useChainId } from "wagmi";

import { Validators200, ValidatorsQueryResponse } from "./gen";

export type Validator = Exclude<Validators200["validators"], undefined>[number];

type Params = {
  address: Address | undefined;
  chainId: number;
};

const getQueryOptions = (params: Params) => {
  return queryOptions({
    queryKey: ["cosmos", "staking", "validators", params.chainId] as const,
    queryFn: async () => {
      invariant(params.address);
      const response = await fetch(
        "/cosmos-api/cosmos/staking/v1beta1/validators"
      );

      const data: ValidatorsQueryResponse = await response.json();

      return { data };
    },

    enabled: Boolean(params.address),
  });
};

export const useValidatorsQuery = () => {
  const chainId = useChainId();
  const { address } = useAccount();
  return useQuery(getQueryOptions({ chainId, address }));
};
